import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import DashboardFilters from './DashboardFilters';

const getTabFromTitle = (title) => {
    if (title.includes('User')) return 'users';
    if (title.includes('Social')) return 'social';
    if (title.includes('Medical')) return 'medical';
    return 'overview';
};

const DetailedPageLayout = ({ title, tab, children, onFilterChange, filters, isSubView = false }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [showFilters, setShowFilters] = useState(false);
    const activeTab = tab || getTabFromTitle(title);

    const categoryConfig = {
        users: {
            show: true,
            label: t('systemDashboard.common.type'),
            options: [
                { value: 'PET_GUARDIAN', label: t('adminDashboard.userTypes.petGuardian') },
                { value: 'VETERINARIAN', label: t('adminDashboard.userTypes.veterinarian') },
                { value: 'SERVICE_PROVIDER', label: t('adminDashboard.userTypes.serviceProvider') },
                { value: 'FIRM', label: t('adminDashboard.userTypes.firm') }
            ]
        },
        social: {
            show: true,
            label: t('systemDashboard.common.type'),
            options: [
                { value: 'post', label: t('systemDashboard.social.post') },
                { value: 'poll', label: t('systemDashboard.social.poll') },
                { value: 'adoption', label: t('systemDashboard.social.adoption') }
            ]
        },
        medical: {
            show: true,
            label: t('systemDashboard.medical.status'),
            options: [
                { value: 'pending', label: t('systemDashboard.medical.statusLabels.pending') },
                { value: 'confirmed', label: t('systemDashboard.medical.statusLabels.confirmed') },
                { value: 'completed', label: t('systemDashboard.medical.statusLabels.completed') },
                { value: 'cancelled', label: t('systemDashboard.medical.statusLabels.cancelled') }
            ]
        },
        overview: {
            show: false
        }
    };

    const handleFilterChange = (newFilters) => {
        if (onFilterChange) onFilterChange(newFilters);
    };

    if (isSubView) {
        return (
            <div className="tab-content sd-detailed-content">
                {children}
            </div>
        );
    }

    return (
        <div className="dashboard-container">
            <div className="dashboard-content">
                <div className="detailed-page-header-sticky">
                    <div className="dashboard-header-mini sd-detailed-header">
                        <div className="sd-detailed-header__left">
                            <button
                                onClick={() => navigate(-1)}
                                className="sd-detailed-header__back"
                                title={t('systemDashboard.detailed.backToDashboard')}
                            >
                                <ArrowLeft size={20} />
                            </button>
                            <div>
                                <h1 className="sd-detailed-header__title">{title}</h1>
                                <p className="sd-detailed-header__subtitle">{t('systemDashboard.detailed.subtitleAnalytics')}</p>
                            </div>
                        </div>
                        <button
                            onClick={() => setShowFilters(!showFilters)}
                            className="sd-filter-toggle"
                        >
                            {showFilters ? t('systemDashboard.detailed.hideFilters') : t('systemDashboard.detailed.showFilters')}
                        </button>
                    </div>

                    {showFilters && (
                        <div className="sd-detailed-filters">
                            <DashboardFilters
                                currentFilters={filters}
                                onFilterChange={handleFilterChange}
                                showCategoryFilter={categoryConfig[activeTab]?.show}
                                categoryLabel={categoryConfig[activeTab]?.label}
                                categories={categoryConfig[activeTab]?.options}
                                activeTab={activeTab}
                            />
                        </div>
                    )}
                </div>

                <div className="tab-content sd-detailed-content">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default DetailedPageLayout;
